const Report = () => import(/* webpackChunkName: "report" */ '@/views/private/report/Index.vue')
const Daily = () => import(/* webpackChunkName: "reportdaily" */ '@/components/report/Daily.vue')
const Product = () => import(/* webpackChunkName: "reportproduct" */ '@/components/report/Product.vue')
const Category = () => import(/* webpackChunkName: "reportcategory" */ '@/components/report/Category.vue')
const Method = () => import(/* webpackChunkName: "reportpaymentmethod" */ '@/components/report/PaymentMethod.vue')
const Customer = () => import(/* webpackChunkName: "reportcustomer" */ '@/components/report/Customer.vue')
const Doctor = () => import(/* webpackChunkName: "reportdoctor" */ '@/components/report/Doctor.vue')
const Therapist = () => import(/* webpackChunkName: "reporttherapist" */ '@/components/report/Therapist.vue')
const TopItems = () => import(/* webpackChunkName: "reporttopitems" */ '@/components/report/TopItems.vue')
const TopCategory = () => import(/* webpackChunkName: "reporttopcategory" */ '@/components/report/TopCategory.vue')

const routes = [
  {
    path: "/report",
    name: "report",
    component: Report,
    meta: {
      title: "Laporan"
    },
    children: [
      {
        path: '/report/by-daily',
        name: 'report daily',
        component: Daily,
        meta: {
          title: "Penjualan Perhari"
        }
      },
      {
        path: '/report/by-product',
        name: 'report product',
        component: Product,
        meta: {
          title: "Penjualan Produk"
        }
      },
      {
        path: '/report/by-category',
        name: 'report category',
        component: Category,
        meta: {
          title: "Penjualan Kategori"
        }
      },
      {
        path: '/report/by-payment-method',
        name: 'report payment method',
        component: Method,
        meta: {
          title: "Laporan Metode Penjualan"
        }
      },
      {
        path: '/report/by-customer',
        name: 'report customer',
        component: Customer,
        meta: {
          title: "Laporan Penjualan berdasarkan Pelanggan"
        }
      },
      {
        path: '/report/by-doctor',
        name: 'report doctor',
        component: Doctor,
        meta: {
          title: "Laporan Penjualan berdasarkan Dokter"
        }
      },
      {
        path: '/report/by-therapist',
        name: 'report therapist',
        component: Therapist,
        meta: {
          title: "Laporan Penjualan berdasarkan Terapis"
        }
      },
      {
        path: '/report/top-item',
        name: 'report top item',
        component: TopItems,
        meta: {
          title: "Laporan Penjualan Top Item"
        }
      },
      {
        path: '/report/top-category',
        name: 'report top category',
        component: TopCategory,
        meta: {
          title: "Laporan Penjualan Kategori"
        }
      },
    ]
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})